var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apollo-query',{attrs:{"query":_vm.query,"variables":{ id: _vm.studentId },"fetchPolicy":_vm.fetchPolicy},on:{"result":_vm.onResult},scopedSlots:_vm._u([{key:"default",fn:function({ result: { loading, error, data } }){return [_vm._t("default",function(){return [_vm._v("Implement required")]},{"sentCurriculums":_vm.curriculums})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }